import { BRANDING } from "../../assets/consts";

export default {
  COLORS: {
    PRIMARY: BRANDING.COLORS.PRIMARY,
    DARK: BRANDING.COLORS.DARK,
    SECONDARY: BRANDING.COLORS.SECONDARY,
    THIRED: BRANDING.COLORS.THIRED,
    MONOCHROME: BRANDING.COLORS.MONOCHROME,
    AREA_ITEM_BACKGROUND: "#ececec99",
    AREA_ITEM_BORDER: "#e7e7e7",
    BACKGROUND: "#e1e6ef",
    LIGHT_MAIN: "#f5f7fa",
    STATUS_BAR: "#f2f2f2",
    DEFAULT: "#172B4D",
    GRAY_LIGHT: "#fafafa",
    PRIMARY_DARK: "#3344a1",
    TL_YELLOW: "#FFCA50",
    TL_PURPLE: BRANDING.COLORS.PRIMARY, // "#802348",
    TL_PURPLE_DARK: "#4A0621",
    ORANGE: "#f37020", // 243.112.33
    SECONDARY: "#F7FAFC",
    LABEL: "#FE2472",
    INFO: "#11CDEF",
    BADGE: "#F5365C",
    ERROR: "#b3261f",
    SUCCESS: "#2DCE89",
    WARNING: "#FB6340",
    /*not yet changed */
    GRAY_DARK: "#666666",
    MUTED: "#ADB5BD",
    INPUT: "#DCDCDC",
    INPUT_SUCCESS: "#7BDEB2",
    INPUT_ERROR: "#FCB3A4",
    ACTIVE: "#5E72E4", //same as primary
    BUTTON_COLOR: "#9C26B0", //wtf
    PLACEHOLDER: "#9FA5AA",
    SWITCH_ON: "#5E72E4",
    SWITCH_OFF: "#D4D9DD",
    GRADIENT_START: "#6B24AA",
    GRADIENT_END: "#AC2688",
    PRICE_COLOR: "#EAD5FB",
    BORDER_COLOR: "#E7E7E7",
    BLOCK: "#E7E7E7",
    ICON: "#172B4D",
    HEADER: "#525F7F",
    BORDER: "#CAD1D7",
    WHITE: "#FFFFFF",
    BLACK: "#000000",
    DEVICE_TYPES: {
      LIGHT: "#ffcc00",
      LIGHT_DARK: "#ffb700",
      CURTAIN: "#6699cc",
      AIR_CONDITIONER: "#99cc99",
      CAMERA: "#cc9966",
      SMART_SPEAKER: "#ad38ad",
      DOORBELL: "#449977",
      POWER_SWITCH: "#00ff99",
      ELEVATOR: "#2F21E0",
      WATERING_SWITCH: "#6699ff",
      ACCESS_CONTROL: "#5cb514",
      OUTLET: "#9933ff",
      OUTLET_LITE: "#8b62b5",
      DOORLOCK: "#666699",
      SENSOR: "#ff9999",
      POWER_METER: "#b79e4d",
      SIREN: "#d9004c",
      BATHROOM: "#8FE3CF",
    },
  },
};
